// extracted by mini-css-extract-plugin
export default {"container":"eNdSQryJ11eFMy3jFl32","header":"piI_tWoF3vHfsZlz7kVo","circle":"omtDzUh3fbFK6qQHcPV7","content":"QIhex1FXfwzu9Apq8_77","footer":"xrwiU7eYvSQi9gL_XLlp"};